import { cn } from "@/lib/utils";

interface SectionTitleProps {
    eyebrow: string;
    title: string;
    subtitle?: string;
    align?: "center" | "left";
}

export function SectionTitle({ eyebrow, title, subtitle, align = "center" }: SectionTitleProps) {
    return (
        <div className={cn("flex flex-col gap-3", align === "center" ? "text-center" : "text-left")}>
            <span
                className={cn(
                    "inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700 dark:text-cyan-200/80 w-fit",
                    align === "center" && "mx-auto"
                )}
            >
                {eyebrow}
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold leading-tight">
                <span className="bg-gradient-to-r from-cyan-600 via-blue-500 to-purple-600 dark:from-cyan-300 dark:via-blue-200 dark:to-purple-300 bg-clip-text text-transparent">
                    {title}
                </span>
            </h2>
            {subtitle && (
                <p className={cn("text-slate-700 dark:text-slate-200/70 text-lg max-w-2xl", align === "center" && "mx-auto")}>
                    {subtitle}
                </p>
            )}
        </div>
    );
}
